<template>
  <div>
    <b-modal
      ref="modal"
      title="Novo Caixa"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <text-input
              v-model="form.description.value"
              :form="form"
              :name="'description'"
              :alias="form.description.alias"
            />
          </div>
        </div>

        <div class="row" v-if="isInsert">
          <div class="col-md-12">
            Tipo:
            <br />
            <br />
            <b-form-radio-group
              id="radio-type"
              v-model="form.type.value"
              name="radio-type-slots"
            >
              <template v-for="(type, index) in accountTypes">
                <b-form-radio :value="index" class="mb-4">
                  <div class="d-flex">
                    <div>
                      <account-icon :type="index" />
                    </div>
                    <div class="ml-2">
                      {{ accountTypes[index].typeDescription }}
                      <br />
                      <small class="text-muted">
                        {{ accountTypes[index].typeHint }}</small
                      >
                    </div>
                  </div>
                </b-form-radio>
              </template>
            </b-form-radio-group>
          </div>
        </div>
        <br />
        <div class="row" v-if="isInsert && hasBalance">
          <div class="col-md-12">
            <number-input
              v-model="form.balance.value"
              :form="form"
              :name="'balance'"
              :alias="form.balance.alias"
            />
          </div>
        </div>

        <template v-if="form.type.value == 'b'">
          <div class="row">
            <div class="col-12">
              <text-input alias="Banco" v-model="form.bank.value" />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <text-input
                alias="Conta Bancária"
                v-model="form.bank_account.value"
              />
            </div>
            <div class="col-6">
              <text-input alias="Agência" v-model="form.bank_agency.value" />
            </div>
          </div>
          <br />
        </template>

        <div class="row mb-4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="mb-2">
                  <span>Quem pode acessar esse caixa:</span>
                </div>
                <b-form-radio-group v-model="form.free_access.value">
                  <b-form-radio value="1"> Todos os usuários </b-form-radio>
                  <b-form-radio value="0">
                    Apenas quem eu selecionar
                  </b-form-radio>
                </b-form-radio-group>
                <template v-if="form.free_access.value == 0">
                  <button
                    class="btn btn-link text-info"
                    @click="showModalUsers()"
                  >
                    Adicionar ou remover usuários
                  </button>
                  <br />
                  <!-- {{ selectedUsers[user].name}}  -->
                  <avatar
                    :title="selectedUsers[user].name"
                    class="ml-2"
                    v-for="(user, index) in selectedUsersId"
                    :key="index"
                    inline
                    color="#fff"
                    :size="30"
                    :username="selectedUsers[user].name"
                    :initials="selectedUsers[user].name.slice(0, 1)"
                  ></avatar>
                </template>

                <b-modal
                  ref="modalUsers"
                  title="Selecione os usuários"
                  header-class="border-bottom-0"
                  footer-class="border-top-0"
                >
                  <div class="container-fluid">
                    <user-select
                      :users="users"
                      v-model="selectedUsersId"
                      @pagechange="selectUsers($event)"
                      @userSelected="addUser($event)"
                    />
                  </div>
                  <div slot="modal-footer">
                    <button
                      role="button"
                      class="btn btn-outline-secondary"
                      @click="$refs.modalUsers.hide()"
                    >
                      <i class="fas fa-arrow-left"></i> Voltar
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-checkbox
              switch
              v-model="form.status.value"
              :value="1"
              :unchecked-value="0"
            >
              <template v-if="form.status.value == 1">
                <span style="cursor: pointer">Caixa Ativo</span>
              </template>
              <template v-else-if="form.status.value == 0">
                <span style="cursor: pointer">Caixa Inativo</span>
              </template>
            </b-form-checkbox>
          </div>
        </div>

        <error-handler :error="error" />
      </div>
      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>


<script>
// todo select users should not be paginated

import Form from "../../../mixins/Form.js";
import Filters from "../../../mixins/Filters.js";
import Avatar from "vue-avatar";
import UserSelect from "../../sections/UserSelect.vue";
import TablePaginator from "../../sections/TablePaginator.vue";
import AccountIcon from "@/components/account/sections/AccountIcon.vue";
import AccountTypes from "@/mixins/account/AccountTypes";

export default {
  components: {
    Avatar,
    UserSelect,
    TablePaginator,
    AccountIcon,
  },

  mixins: [AccountTypes],

  data: function () {
    return {
      step: 1,

      form: new Form({
        id: {
          default: null,
        },

        description: {
          alias: "Descrição",
          validate: {
            required: true,
          },
        },

        type: {
          alias: "Tipo de Conta",
          default: "c",
          validate: {
            required: true,
          },
        },

        balance: {
          alias: "Saldo Inicial",
          default: 0,
        },

        bank: {},

        bank_agency: {},

        bank_account: {},

        free_access: {
          default: 1, // a - all  / s - selected
        },
        status: {
          default: 1,
        },
      }),

      selectedUsers: {},
      selectedUsersId: [],

      users: {},

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  computed: {
    free_access() {
      return this.form.free_access.value;
    },

    isInsert() {
      return this.form.id.value == "";
    },

    hasBalance() {
      return (this.form.type.value !== 'd') 
    },

    url() {
      return this.form.id.value == ""
        ? "../api/account/store"
        : "../api/account/store/" + this.form.id.value;
    },
  },

  watch: {
    free_access(val) {
      // if (val == 0) {
      //   this.selectUsers()
      // }
    },

    hasBalance() {
      if (!this.hasBalance) {
        this.form.balance.value = 0
      }
    },
  },

  methods: {
    async open(id = null) {
      this.error = null;
      this.selectedUsers = {};
      this.selectedUsersId = [];

      this.form.reset();

      if (id) {
        await this.selectAccount(id);
      }

      this.$refs.modal.show();
    },

    addUser(user) {
      this.selectedUsers[user.id] = user;
    },

    selectUsers(page = 1) {
      axios
        .post("../api/user/select?page=" + page, { pages: 5 })
        .then((response) => {
          this.users = response.data;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    showModalUsers(page = 1) {
      this.$store.commit("showLoading");
      axios
        .post("../api/user/select?page=" + page, { pages: 5 })
        .then((response) => {
          this.users = response.data;
          this.$store.commit("hideLoading");
          this.$refs.modalUsers.show();
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    store() {
      if (this.form.isValid()) {
        this.$store.commit("showLoading");

        let form = {
          ...this.form.getValues(),
          ...{ users: this.selectedUsersId },
        };

        axios
          .post(this.url, form)
          .then((response) => {
            this.$emit("stored");

            this.$store.commit("showAlert", {
              message: "Caixa Cadastrado com Sucesso!",
              type: "success",
            });

            this.$refs.modal.hide();

            this.$store.commit("hideLoading");
          })
          .catch((error) => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      }
    },

    async selectAccount(id) {
      await axios
        .post("../api/account/edit/" + id)
        .then((response) => {
          this.form.setValues(response.data.account);
          this.selectedUsersId = response.data.account.account_permission_join_user.map(
            function (obj) {
              return obj.user_id;
            }
          );
          this.selectedUsers = response.data.users;
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>

<style>
.card-selectable {
  cursor: pointer;
}

.card-selected {
  border-color: #8bc34a;
}

.card-selectable:hover {
  border-color: #8bc34a;
}
</style>
